(function () {
    'use strict';

    angular
        .module('app')
        .factory('searchForChildrenService', searchForChildrenService);

    searchForChildrenService.$inject = ['$http', '$localStorage', '$q', 'breadCrumbService', 'loginService'];

    function searchForChildrenService($http, $localStorage, $q, breadCrumbService, loginService) {
        var service = {
            currentItem: {},
            records: [],
            getData: getData,
            getCount: getCount
        };

        return service;

        //Search For Children getData
        function getData(skip, take, totalRecords, sort, sortDirection, countOperation, resultType, columns) {
            var deferred = $q.defer();

            if (Object.keys(service.currentItem).length == 0) {
                if ($localStorage.userSettings["searchForChildrenServiceItem"] != undefined) {
                    service.currentItem = $localStorage.userSettings["searchForChildrenServiceItem"];
                }
                else {
                    throw "No search item available";
                }
            }
            service.currentItem.take = take;
            service.currentItem.skip = skip;

            //set the breadcrumb data to search for children/filename
            breadCrumbService.category = loginService.resourceStrings["SEARCH_FOR_CHILDREN"];
            breadCrumbService.details = service.currentItem.filename;

            //save the current into local storage
            $localStorage.userSettings["searchForChildrenServiceItem"] = service.currentItem;
            var responseType = resultType == 2 || resultType == 3 ? "arraybuffer" : "";
            //define objects required for call
            var adeptDataTable = { TableDefinition: null, TableRecords: null, RecordCount: totalRecords, Take: take, Skip: skip };

            //define the required object for the controller
            var searchForChildrenObject = {
                parentFileId: service.currentItem.fileId,
                parentMajorRev: service.currentItem.majRev,
                parentMinorRev: service.currentItem.minRev,
                countOperation: countOperation,
                adeptDataTable: adeptDataTable,
                resultType: resultType,
                columns: columns,
                stopAtSubtypes: 0, //Bill 06-20-2018 Add stopAtSubTypes for CAD integrations
                sort: { SortField: sort, SortOrder: sortDirection },
                takeSkip: { Take: take, Skip: skip }
            };
            //remove condition b/c it's not needed
            //if (service.records.length == 0) {
                var request = $http({
                    url: '../Synergis.WebApi/api/Document/searchForChildren/',
                    method: 'POST',
                    responseType: responseType,
                    data: JSON.stringify(searchForChildrenObject),
                    headers: {
                        "Content-Type": "application/json"
                    }
                }).then(function (response) {
                    //remove records assignment b/c it's not needed
                    //service.records = response.data.AdeptDataTable.TableRecords ? response.data.AdeptDataTable.TableRecords : response.data;
                    service.loading = false;
                    deferred.resolve(response);
                }, function (response) {
                    deferred.reject(response);
                })
            //}
            return { promise: deferred.promise };
        };


        //Search for children - getCount
        function getCount() {
            var deferred = $q.defer();
            service.getData(0, 0, 0, "SCHEMA_S_LONGNAME", 0, true).promise.then(function (response) {
                deferred.resolve(response.data.AdeptDataTable.RecordCount);
            });
            return deferred.promise;
        }

    }
})();